import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=5cddff92&scoped=true&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"
import style0 from "./admin.vue?vue&type=style&index=0&id=5cddff92&prod&lang=css&"
import style1 from "./admin.vue?vue&type=style&index=1&id=5cddff92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cddff92",
  null
  
)

export default component.exports